import { render } from "./approvals.vue?vue&type=template&id=91e1785e&scoped=true"
import script from "./approvals.vue?vue&type=script&lang=js"
export * from "./approvals.vue?vue&type=script&lang=js"

import "./approvals.vue?vue&type=style&index=0&id=91e1785e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91e1785e"]])

export default __exports__